<template>
  <b-card :title="title" class="mb-3">
    <slot name="content">
      <div class="numbers-container">
        <b-container v-if="numbers" fluid>
          <b-row>
            <b-col v-for="(number, index) in numbers" :key="index" :sm="cols">
              <slot :item="number" name="item">
                <big-numbers :item="number" />
              </slot>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </slot>
    <slot v-if="link" name="link">
      <b-button
        :to="link"
        variant="primary"
        class="text-uppercase"
        block
      >
        {{ $t('actions.see_more') }}
      </b-button>
    </slot>
  </b-card>
</template>

<script>
  import BigNumbers from '@/components/big-numbers';

  export default {
    name: 'DashboardCardComponent',
    components: {
      BigNumbers,
    },
    props: {
      title: {
        type: String,
        default: '',
      },
      link: {
        type: [String, Object],
        default: null,
      },
      numbers: {
        type: Array,
        default: null,
      },
    },
    computed: {
      cols() {
        return 12 / this.numbers.length;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  /deep/.card {
    padding: 1.5rem;

    .numbers-container {
      margin: 2rem 0;
    }
  }
</style>
